// BLOGS
export const CREATE_BLOG = "CREATE_BLOG ";
export const FETCH_BLOGS = "FETCH_BLOGS ";
export const FETCH_BLOG_ID = " FETCH_BLOG_ID ";
export const UPDATE_BLOG = "  UPDATE_BLOG ";
export const DELETE_BLOG = "DELETE_BLOG";

// CATEGORY
export const FETCH_CATEGORY = "FETCH_CATEGORY ";
export const FETCH_CATEGORY_ID = "FETCH_CATEGORY_ID ";

// LIKE
export const TOGGLE_LIKE = "TOGGLE_LIKE";

//  AUTH
export const AUTH = "AUTH ";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_ID = "FETCH_USER_ID";
export const LOGOUT = "LOGOUT";


